type PageTitleProps = {
  title: string
}

export function PageTitle({ title }: PageTitleProps) {
  return <title>{`${title} | Studio`}</title>
}
